import { Icon } from '@iconify/react'
import { useRouter } from '@tanstack/react-router'
import * as React from 'react'

import img404 from '~in-app/assets/404.jpg'
import { Button } from '~in-app/components/shadcn-ui'

type NotFoundProps = {
  showBackButton?: boolean
}

const DefaultNotFound = (props: NotFoundProps = { showBackButton: false }) => {
  const router = useRouter()

  const onBack = () => router.history.back()

  return (
    <div className="container mx-auto h-full">
      <div className="flex size-full items-center justify-center">
        <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
          <div className="flex flex-col gap-4 sm:w-1/2">
            <div className="text-center text-error-500 md:text-start">404</div>
            <div className="text-center text-xl font-bold text-error-500 md:text-start">Page Not Found</div>

            <div className="text-center text-muted-foreground md:text-start">
              If you typed the URL directly, please make sure the spelling is correct.
            </div>

            {
              props.showBackButton && (
                <Button
                  hasIcon
                  className="p-0 md:justify-start"
                  variant="link"
                  onClick={onBack}
                >
                  <Icon
                    height="16"
                    icon="lucide:arrow-left"
                    width="16"
                  />
                  Back
                </Button>
              )
            }

          </div>

          <img
            alt="404-not-found"
            className="rounded-md shadow-md"
            height={400}
            src={img404}
            style={{ objectFit: 'contain' }}
            width={400}
          />
        </div>
      </div>
    </div>
  )
}

export { DefaultNotFound }
